//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './DataBlockFieldClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetDataBlockFieldQueryParameters = {
  dataBlockTypeId?: number | null | undefined ;
}

export type GetByIdDataBlockFieldQueryParameters = {
  id: number ;
}

export type PatchDataBlockFieldQueryParameters = {
  id: number ;
}

export type RemoveDataBlockFieldQueryParameters = {
  id: number ;
}

export type GetById2DataBlockFieldQueryParameters = {
  id: number ;
}

export type RenameFieldDataBlockFieldQueryParameters = {
  id: number ;
}

export type GetExistingValuesDataBlockFieldQueryParameters = {
  dataBlockFieldId: number ;
  tableColumn?: string | null | undefined ;
  tableRowFilter_ColumnName?: string | null | undefined ;
  tableRowFilter_ColumnValue?: string | null | undefined ;
}

export type GetDataBlockFieldsForEditingDataBlockFieldQueryParameters = {
  dataBlockTypeId: number ;
}

export type ConvertFieldToDictionaryDataBlockFieldQueryParameters = {
  id: number ;
}

export type CreateDictionaryItemsFromCustomValuesDataBlockFieldQueryParameters = {
  id: number ;
}

export function createUrl(): string {
  let url_ = getBaseUrl() + "/api/data-blocks/fields";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createMutationKey(): MutationKey {
  return trimArrayEnd([
      'DataBlockFieldClient',
      'create',
    ]);
}

export function useCreateMutation<TContext>(options?: Omit<UseMutationOptions<Types.DataBlockFieldDto, unknown, Types.CreateDataBlockFieldDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.DataBlockFieldDto, unknown, Types.CreateDataBlockFieldDto, TContext> {
  const key = createMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CreateDataBlockFieldDto) => Client.create(dto),
    mutationKey: key,
  });
}
  
export function getUrl(dataBlockTypeId?: number | null | undefined): string {
  let url_ = getBaseUrl() + "/api/data-blocks/fields?";
if (dataBlockTypeId !== undefined && dataBlockTypeId !== null)
    url_ += "DataBlockTypeId=" + encodeURIComponent("" + dataBlockTypeId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.DataBlockFieldDto[], unknown, Types.DataBlockFieldDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.DataBlockFieldDto[], unknown, Types.DataBlockFieldDto[]>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(dataBlockTypeId?: number | null | undefined): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { dataBlockTypeId,  } = params[0] as GetDataBlockFieldQueryParameters;

    return trimArrayEnd([
        'DataBlockFieldClient',
        'get',
        dataBlockTypeId as any,
      ]);
  } else {
    return trimArrayEnd([
        'DataBlockFieldClient',
        'get',
        ...params
      ]);
  }
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
      context.queryKey[2] as number | null | undefined,axiosConfig    );
}

export function useGetQuery<TSelectData = Types.DataBlockFieldDto[], TError = unknown>(dto: GetDataBlockFieldQueryParameters, options?: Omit<UseQueryOptions<Types.DataBlockFieldDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetQuery<TSelectData = Types.DataBlockFieldDto[], TError = unknown>(dataBlockTypeId?: number | null | undefined, options?: Omit<UseQueryOptions<Types.DataBlockFieldDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.DataBlockFieldDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.DataBlockFieldDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let dataBlockTypeId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ dataBlockTypeId,  } = params[0] as GetDataBlockFieldQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [dataBlockTypeId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.DataBlockFieldDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(dataBlockTypeId),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.DataBlockFieldDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetData(queryClient: QueryClient, updater: (data: Types.DataBlockFieldDto[] | undefined) => Types.DataBlockFieldDto[], dataBlockTypeId?: number | null | undefined) {
  queryClient.setQueryData(getQueryKey(dataBlockTypeId),
    updater
  );
}

export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.DataBlockFieldDto[] | undefined) => Types.DataBlockFieldDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function getByIdUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/data-blocks/fields/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getByIdDefaultOptions: Omit<UseQueryOptions<Types.DataBlockFieldDto, unknown, Types.DataBlockFieldDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.DataBlockFieldDto, unknown, Types.DataBlockFieldDto>, 'queryFn'>> = {
};
export function getGetByIdDefaultOptions() {
  return getByIdDefaultOptions;
};
export function setGetByIdDefaultOptions(options: typeof getByIdDefaultOptions) {
  getByIdDefaultOptions = options;
}

export function getByIdQueryKey(id: number): QueryKey;
export function getByIdQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetByIdDataBlockFieldQueryParameters;

    return trimArrayEnd([
        'DataBlockFieldClient',
        'getById',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'DataBlockFieldClient',
        'getById',
        ...params
      ]);
  }
}
export function __getById(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getById(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetByIdQuery<TSelectData = Types.DataBlockFieldDto, TError = unknown>(dto: GetByIdDataBlockFieldQueryParameters, options?: Omit<UseQueryOptions<Types.DataBlockFieldDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetByIdQuery<TSelectData = Types.DataBlockFieldDto, TError = unknown>(id: number, options?: Omit<UseQueryOptions<Types.DataBlockFieldDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetByIdQuery<TSelectData = Types.DataBlockFieldDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.DataBlockFieldDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetByIdDataBlockFieldQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.DataBlockFieldDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getById(context, axiosConfig) : __getById,
    queryKey: getByIdQueryKey(id),
    ...getByIdDefaultOptions as unknown as Omit<UseQueryOptions<Types.DataBlockFieldDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetByIdData(queryClient: QueryClient, updater: (data: Types.DataBlockFieldDto | undefined) => Types.DataBlockFieldDto, id: number) {
  queryClient.setQueryData(getByIdQueryKey(id),
    updater
  );
}

export function setGetByIdDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.DataBlockFieldDto | undefined) => Types.DataBlockFieldDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function patchUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/data-blocks/fields/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'DataBlockFieldClient',
      'patch',
      id as any,
    ]);
}

export function usePatchMutation<TContext>(id: number, options?: Omit<UseMutationOptions<Types.DataBlockFieldDto, unknown, Types.PatchDataBlockFieldDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.DataBlockFieldDto, unknown, Types.PatchDataBlockFieldDto, TContext> {
  const key = patchMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.PatchDataBlockFieldDto) => Client.patch(id, dto),
    mutationKey: key,
  });
}
  
type Patch__MutationParameters = PatchDataBlockFieldQueryParameters & {
  dto: Types.PatchDataBlockFieldDto;
}

export function usePatchMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.DataBlockFieldDto, unknown, Patch__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PatchDataBlockFieldQueryParameters}): UseMutationResult<Types.DataBlockFieldDto, unknown, Patch__MutationParameters, TContext> {
  const key = patchMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Patch__MutationParameters) => Client.patch(data.id ?? options?.parameters?.id!, data.dto),
  mutationKey: key,
});
}
  
export function removeUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/data-blocks/fields/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'DataBlockFieldClient',
      'remove',
      id as any,
    ]);
}

export function useRemoveMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.remove(id),
    mutationKey: key,
  });
}
  
type Remove__MutationParameters = RemoveDataBlockFieldQueryParameters

export function useRemoveMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Remove__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: RemoveDataBlockFieldQueryParameters}): UseMutationResult<void, unknown, Remove__MutationParameters, TContext> {
  const key = removeMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Remove__MutationParameters) => Client.remove(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function getById2Url(id: number): string {
  let url_ = getBaseUrl() + "/api/data-blocks/fields/by-id/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getById2DefaultOptions: Omit<UseQueryOptions<Types.DataBlockFieldDto, unknown, Types.DataBlockFieldDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.DataBlockFieldDto, unknown, Types.DataBlockFieldDto>, 'queryFn'>> = {
};
export function getGetById2DefaultOptions() {
  return getById2DefaultOptions;
};
export function setGetById2DefaultOptions(options: typeof getById2DefaultOptions) {
  getById2DefaultOptions = options;
}

export function getById2QueryKey(id: number): QueryKey;
export function getById2QueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetById2DataBlockFieldQueryParameters;

    return trimArrayEnd([
        'DataBlockFieldClient',
        'getById2',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'DataBlockFieldClient',
        'getById2',
        ...params
      ]);
  }
}
export function __getById2(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getById2(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetById2Query<TSelectData = Types.DataBlockFieldDto, TError = unknown>(dto: GetById2DataBlockFieldQueryParameters, options?: Omit<UseQueryOptions<Types.DataBlockFieldDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetById2Query<TSelectData = Types.DataBlockFieldDto, TError = unknown>(id: number, options?: Omit<UseQueryOptions<Types.DataBlockFieldDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetById2Query<TSelectData = Types.DataBlockFieldDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.DataBlockFieldDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetById2DataBlockFieldQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.DataBlockFieldDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getById2(context, axiosConfig) : __getById2,
    queryKey: getById2QueryKey(id),
    ...getById2DefaultOptions as unknown as Omit<UseQueryOptions<Types.DataBlockFieldDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetById2Data(queryClient: QueryClient, updater: (data: Types.DataBlockFieldDto | undefined) => Types.DataBlockFieldDto, id: number) {
  queryClient.setQueryData(getById2QueryKey(id),
    updater
  );
}

export function setGetById2DataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.DataBlockFieldDto | undefined) => Types.DataBlockFieldDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function renameFieldUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/data-blocks/fields/{id}/name";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function renameFieldMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'DataBlockFieldClient',
      'renameField',
      id as any,
    ]);
}

export function useRenameFieldMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, Types.RenameDataBlockFieldDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.RenameDataBlockFieldDto, TContext> {
  const key = renameFieldMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.RenameDataBlockFieldDto) => Client.renameField(id, dto),
    mutationKey: key,
  });
}
  
type RenameField__MutationParameters = RenameFieldDataBlockFieldQueryParameters & {
  dto: Types.RenameDataBlockFieldDto;
}

export function useRenameFieldMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, RenameField__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: RenameFieldDataBlockFieldQueryParameters}): UseMutationResult<void, unknown, RenameField__MutationParameters, TContext> {
  const key = renameFieldMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: RenameField__MutationParameters) => Client.renameField(data.id ?? options?.parameters?.id!, data.dto),
  mutationKey: key,
});
}
  
export function getExistingValuesUrl(dataBlockFieldId: number, tableColumn?: string | null | undefined, tableRowFilter_ColumnName?: string | null | undefined, tableRowFilter_ColumnValue?: string | null | undefined): string {
  let url_ = getBaseUrl() + "/api/data-blocks/fields/{dataBlockFieldId}/values?";
if (dataBlockFieldId === undefined || dataBlockFieldId === null)
  throw new Error("The parameter 'dataBlockFieldId' must be defined.");
url_ = url_.replace("{dataBlockFieldId}", encodeURIComponent("" + dataBlockFieldId));
if (tableColumn !== undefined && tableColumn !== null)
    url_ += "TableColumn=" + encodeURIComponent("" + tableColumn) + "&";
if (tableRowFilter_ColumnName !== undefined && tableRowFilter_ColumnName !== null)
    url_ += "TableRowFilter.ColumnName=" + encodeURIComponent("" + tableRowFilter_ColumnName) + "&";
if (tableRowFilter_ColumnValue !== undefined && tableRowFilter_ColumnValue !== null)
    url_ += "TableRowFilter.ColumnValue=" + encodeURIComponent("" + tableRowFilter_ColumnValue) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getExistingValuesDefaultOptions: Omit<UseQueryOptions<string[], unknown, string[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<string[], unknown, string[]>, 'queryFn'>> = {
};
export function getGetExistingValuesDefaultOptions() {
  return getExistingValuesDefaultOptions;
};
export function setGetExistingValuesDefaultOptions(options: typeof getExistingValuesDefaultOptions) {
  getExistingValuesDefaultOptions = options;
}

export function getExistingValuesQueryKey(dto: GetExistingValuesDataBlockFieldQueryParameters): QueryKey;
export function getExistingValuesQueryKey(dataBlockFieldId: number, tableColumn?: string | null | undefined, tableRowFilter_ColumnName?: string | null | undefined, tableRowFilter_ColumnValue?: string | null | undefined): QueryKey;
export function getExistingValuesQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { dataBlockFieldId, tableColumn, tableRowFilter_ColumnName, tableRowFilter_ColumnValue,  } = params[0] as GetExistingValuesDataBlockFieldQueryParameters;

    return trimArrayEnd([
        'DataBlockFieldClient',
        'getExistingValues',
        dataBlockFieldId as any,
        tableColumn as any,
        tableRowFilter_ColumnName as any,
        tableRowFilter_ColumnValue as any,
      ]);
  } else {
    return trimArrayEnd([
        'DataBlockFieldClient',
        'getExistingValues',
        ...params
      ]);
  }
}
export function __getExistingValues(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getExistingValues(
      context.queryKey[2] as number,       context.queryKey[3] as string | null | undefined,       context.queryKey[4] as string | null | undefined,       context.queryKey[5] as string | null | undefined,axiosConfig    );
}

export function useGetExistingValuesQuery<TSelectData = string[], TError = unknown>(dto: GetExistingValuesDataBlockFieldQueryParameters, options?: Omit<UseQueryOptions<string[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Returns all existing values for dataBlockFieldId.
If field is a table, returns all values of a dto.TableColumn.TableColumn
 * @param tableColumn (optional) 
 * @param tableRowFilter_ColumnName (optional) 
 * @param tableRowFilter_ColumnValue (optional) 
 */
export function useGetExistingValuesQuery<TSelectData = string[], TError = unknown>(dataBlockFieldId: number, tableColumn?: string | null | undefined, tableRowFilter_ColumnName?: string | null | undefined, tableRowFilter_ColumnValue?: string | null | undefined, options?: Omit<UseQueryOptions<string[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetExistingValuesQuery<TSelectData = string[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<string[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let dataBlockFieldId: any = undefined;
  let tableColumn: any = undefined;
  let tableRowFilter_ColumnName: any = undefined;
  let tableRowFilter_ColumnValue: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ dataBlockFieldId, tableColumn, tableRowFilter_ColumnName, tableRowFilter_ColumnValue,  } = params[0] as GetExistingValuesDataBlockFieldQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [dataBlockFieldId, tableColumn, tableRowFilter_ColumnName, tableRowFilter_ColumnValue, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<string[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getExistingValues(context, axiosConfig) : __getExistingValues,
    queryKey: getExistingValuesQueryKey(dataBlockFieldId, tableColumn, tableRowFilter_ColumnName, tableRowFilter_ColumnValue),
    ...getExistingValuesDefaultOptions as unknown as Omit<UseQueryOptions<string[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Returns all existing values for dataBlockFieldId.
If field is a table, returns all values of a dto.TableColumn.TableColumn
 * @param tableColumn (optional) 
 * @param tableRowFilter_ColumnName (optional) 
 * @param tableRowFilter_ColumnValue (optional) 
 */
export function setGetExistingValuesData(queryClient: QueryClient, updater: (data: string[] | undefined) => string[], dataBlockFieldId: number, tableColumn?: string | null | undefined, tableRowFilter_ColumnName?: string | null | undefined, tableRowFilter_ColumnValue?: string | null | undefined) {
  queryClient.setQueryData(getExistingValuesQueryKey(dataBlockFieldId, tableColumn, tableRowFilter_ColumnName, tableRowFilter_ColumnValue),
    updater
  );
}

/**
 * Returns all existing values for dataBlockFieldId.
If field is a table, returns all values of a dto.TableColumn.TableColumn
 * @param tableColumn (optional) 
 * @param tableRowFilter_ColumnName (optional) 
 * @param tableRowFilter_ColumnValue (optional) 
 */
export function setGetExistingValuesDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: string[] | undefined) => string[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function getDataBlockFieldsForEditingUrl(dataBlockTypeId: number): string {
  let url_ = getBaseUrl() + "/api/data-blocks/fields/edit/{dataBlockTypeId}";
if (dataBlockTypeId === undefined || dataBlockTypeId === null)
  throw new Error("The parameter 'dataBlockTypeId' must be defined.");
url_ = url_.replace("{dataBlockTypeId}", encodeURIComponent("" + dataBlockTypeId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDataBlockFieldsForEditingDefaultOptions: Omit<UseQueryOptions<Types.DataBlockFieldListDto[], unknown, Types.DataBlockFieldListDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.DataBlockFieldListDto[], unknown, Types.DataBlockFieldListDto[]>, 'queryFn'>> = {
};
export function getGetDataBlockFieldsForEditingDefaultOptions() {
  return getDataBlockFieldsForEditingDefaultOptions;
};
export function setGetDataBlockFieldsForEditingDefaultOptions(options: typeof getDataBlockFieldsForEditingDefaultOptions) {
  getDataBlockFieldsForEditingDefaultOptions = options;
}

export function getDataBlockFieldsForEditingQueryKey(dataBlockTypeId: number): QueryKey;
export function getDataBlockFieldsForEditingQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { dataBlockTypeId,  } = params[0] as GetDataBlockFieldsForEditingDataBlockFieldQueryParameters;

    return trimArrayEnd([
        'DataBlockFieldClient',
        'getDataBlockFieldsForEditing',
        dataBlockTypeId as any,
      ]);
  } else {
    return trimArrayEnd([
        'DataBlockFieldClient',
        'getDataBlockFieldsForEditing',
        ...params
      ]);
  }
}
export function __getDataBlockFieldsForEditing(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getDataBlockFieldsForEditing(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetDataBlockFieldsForEditingQuery<TSelectData = Types.DataBlockFieldListDto[], TError = unknown>(dto: GetDataBlockFieldsForEditingDataBlockFieldQueryParameters, options?: Omit<UseQueryOptions<Types.DataBlockFieldListDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetDataBlockFieldsForEditingQuery<TSelectData = Types.DataBlockFieldListDto[], TError = unknown>(dataBlockTypeId: number, options?: Omit<UseQueryOptions<Types.DataBlockFieldListDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetDataBlockFieldsForEditingQuery<TSelectData = Types.DataBlockFieldListDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.DataBlockFieldListDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let dataBlockTypeId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ dataBlockTypeId,  } = params[0] as GetDataBlockFieldsForEditingDataBlockFieldQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [dataBlockTypeId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.DataBlockFieldListDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getDataBlockFieldsForEditing(context, axiosConfig) : __getDataBlockFieldsForEditing,
    queryKey: getDataBlockFieldsForEditingQueryKey(dataBlockTypeId),
    ...getDataBlockFieldsForEditingDefaultOptions as unknown as Omit<UseQueryOptions<Types.DataBlockFieldListDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetDataBlockFieldsForEditingData(queryClient: QueryClient, updater: (data: Types.DataBlockFieldListDto[] | undefined) => Types.DataBlockFieldListDto[], dataBlockTypeId: number) {
  queryClient.setQueryData(getDataBlockFieldsForEditingQueryKey(dataBlockTypeId),
    updater
  );
}

export function setGetDataBlockFieldsForEditingDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.DataBlockFieldListDto[] | undefined) => Types.DataBlockFieldListDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function convertFieldToDictionaryUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/data-blocks/fields/{id}/convert-to-dictionary";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function convertFieldToDictionaryMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'DataBlockFieldClient',
      'convertFieldToDictionary',
      id as any,
    ]);
}

export function useConvertFieldToDictionaryMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, Types.ConvertFieldToDictionaryDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.ConvertFieldToDictionaryDto, TContext> {
  const key = convertFieldToDictionaryMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.ConvertFieldToDictionaryDto) => Client.convertFieldToDictionary(id, dto),
    mutationKey: key,
  });
}
  
type ConvertFieldToDictionary__MutationParameters = ConvertFieldToDictionaryDataBlockFieldQueryParameters & {
  dto: Types.ConvertFieldToDictionaryDto;
}

export function useConvertFieldToDictionaryMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, ConvertFieldToDictionary__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: ConvertFieldToDictionaryDataBlockFieldQueryParameters}): UseMutationResult<void, unknown, ConvertFieldToDictionary__MutationParameters, TContext> {
  const key = convertFieldToDictionaryMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: ConvertFieldToDictionary__MutationParameters) => Client.convertFieldToDictionary(data.id ?? options?.parameters?.id!, data.dto),
  mutationKey: key,
});
}
  
export function createDictionaryItemsFromCustomValuesUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/data-blocks/fields/{id}/convert-custom-values-to-dictionary-items";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createDictionaryItemsFromCustomValuesMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'DataBlockFieldClient',
      'createDictionaryItemsFromCustomValues',
      id as any,
    ]);
}

/**
 * Used for Dictionary fields with custom option, when converting them to Dictionary without option.
Method converts all existing Custom values to regular Dictionary Items
 */
export function useCreateDictionaryItemsFromCustomValuesMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = createDictionaryItemsFromCustomValuesMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.createDictionaryItemsFromCustomValues(id),
    mutationKey: key,
  });
}
  
type CreateDictionaryItemsFromCustomValues__MutationParameters = CreateDictionaryItemsFromCustomValuesDataBlockFieldQueryParameters

/**
 * Used for Dictionary fields with custom option, when converting them to Dictionary without option.
Method converts all existing Custom values to regular Dictionary Items
 */
export function useCreateDictionaryItemsFromCustomValuesMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, CreateDictionaryItemsFromCustomValues__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: CreateDictionaryItemsFromCustomValuesDataBlockFieldQueryParameters}): UseMutationResult<void, unknown, CreateDictionaryItemsFromCustomValues__MutationParameters, TContext> {
  const key = createDictionaryItemsFromCustomValuesMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: CreateDictionaryItemsFromCustomValues__MutationParameters) => Client.createDictionaryItemsFromCustomValues(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}